<div id="table-toolbar">
  <span id="table-info" class="sdps-text-body">
    <mm-total-results [displayedRows]="displayedRows" ></mm-total-results>
  </span>
  <span *ngIf="showTableOptions" id="table-options">
    <mm-table-option [schwabIcon]="'print'" [text]="'Print'" (click)="printTable($event)"></mm-table-option>
    <mm-table-option [schwabIcon]="'download'" [text]="'Export'" (click)="exportTable()"></mm-table-option>
    <mm-table-option *ngIf="displayMasterStatusViewBookmarks" data-testid="bookmarkFilterOption" [schwabIcon]="bookmarkIcon$.asObservable() | async" [text]="'Bookmarks'" (click)="onBookmarkFilterClicked()"></mm-table-option>
  </span>
</div>
<div>
<span>
  <ag-grid-angular class="sac-ag-grid ag-theme-material" [style.height]="height"
    [rowData]="rowData" [columnDefs]="columnDefs" [defaultColDef]="defaultColumnDef" [modules]="modules" [icons]="icons"
    [headerHeight]="headerHeight" [floatingFiltersHeight]="25" [components]="frameworkComponents" [gridOptions]="gridOptions"
    [sortingOrder]="sortingOrder" [pagination]="true" [paginationPageSize]="10" [suppressPaginationPanel]="true"
    [suppressMultiSort]="true" (gridReady)="onGridReady($event)" (filterChanged)="onFilterChanged($event)"
    [suppressDragLeaveHidesColumns]="true" [noRowsOverlayComponent]="customErrorComponent" (sortChanged)="onSortChanged($event)"
    [noRowsOverlayComponentParams]="customErrorComponentParams" [suppressNoRowsOverlay]="true" (rowDataUpdated)="onRowDataUpdated()" (columnMoved)="onColumnMoved($event)"
    (dragStopped)="onDragStopped($event)" [loadingOverlayComponent]="loadingOverlayComponent" [loadingOverlayComponentParams]="loadingOverlayComponentParams"
    [floatingFilter]="showFloatingFilter" [enableRangeSelection]="true" [suppressCellFocus]="true">
  </ag-grid-angular>
</span>
  <mm-pagination [gridApi]="gridApi" [fileName]="fileName" [showPaginationMessage]="showPaginationMessage" [showInfoIcon]="showDisclaimerInfoIcon" (pageChanged)="onPaginationChanged()"></mm-pagination>
</div>
<mm-print-friendly-modal [showModal]="showPrintFriendlyModal"
[masterTableName]="masterTableName" [accountNumber]="accountNumber" (printButtonClicked)="printFriendlyButtonClicked($event)" [gridApi]="gridApi" [gridColumnApi]="gridColumnApi" >
</mm-print-friendly-modal>
